// eslint-disable-next-line jira/filename-case
import React, { type ComponentType } from 'react';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@jira/platform__skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint, type PreloadPriority } from '@atlassian/react-loosely-lazy';
import type { Cleanup } from '@atlassian/react-loosely-lazy/cleanup';
import type { IssueTableGadgetEditData } from '../../../types.tsx';

const LazyAssignedToMeGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetEditData>>
>(() => import(/* webpackChunkName: "async-react-assigned-to-me-gadget-edit" */ './main.tsx'));

export const AssignedToMeGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetEditData>,
): React.JSX.Element => (
	<Placeholder name="assigned-to-me-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyAssignedToMeGadgetEdit {...props} />
	</Placeholder>
);

export const preload: (priority?: PreloadPriority) => Cleanup = LazyAssignedToMeGadgetEdit.preload;
